import Avatar from '@mui/material/Avatar';

function TableInitialsCircle({
  userName,
  size,
}: {
  userName: string;
  size?: number;
}) {
  const getInitials = (name: string) => {
    const parts = name.trim().split(' ');
    if (parts.length > 1) {
      return parts
        .slice(0, 2)
        .map((part) => part[0])
        .join('');
    } else {
      return name.substring(0, 2).toUpperCase();
    }
  };

  // Updated to generate more vivid colors
  const strToHslColor = (str: string, saturation = 50, lightness = 65) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360; // Hue derived from name
    return `hsl(${h}, ${saturation}%, ${lightness}%)`;
  };

  let initials = userName ? getInitials(userName) : getInitials('User');
  let hasValidInitials = initials.length > 0;

  return (
    <Avatar
      sx={{
        bgcolor: strToHslColor(userName), // Use updated strToHslColor
        width: size ? `${size}px` : '35px',
        height: size ? `${size}px` : '35px',
        fontSize: '12px',
      }}
      alt={hasValidInitials ? userName : 'User'}
      src={hasValidInitials ? undefined : '/broken-image.jpg'}
    >
      {initials}
    </Avatar>
  );
}

export default TableInitialsCircle;
